<template>
  <v-container
    id="edit-agency"
    fluid
    tag="section"
  >
    <v-card
      class="mx-auto pa-5"
      outlined
    >
      <validation-observer v-slot="{ handleSubmit }">
        <v-form
          @submit.prevent="handleSubmit(update)"
        >
          <h3>
            Thông tin đại lý
          </h3>

          <v-alert
            v-show="alertMessageText"
            v-model="alert"
            :type="alertMessageType"
            dismissible
          >
            {{ alertMessageText }}
          </v-alert>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Tên đại lý"
                rules="required|max:255"
              >
                <v-text-field
                  v-model="agency.name"
                  label="Tên đại lý *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider v-slot="{ errors }" name="Tỉnh/thành phố" :rules="{required: provinces.length > 0}">
                <v-autocomplete
                  v-model="agency.tinhId"
                  :items="provinces"
                  item-text="ten"
                  item-value="id"
                  label="Tỉnh/thành phố *"
                  @change="onChangeProvince"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                :rules="{ required, max:11, numeric, regex: /((09|03|07|08|05|849|843|847|848|845)+([0-9]{8})\b)/g }"
                name="Số điện thoại"
              >
                <v-text-field
                  v-model="agency.phone"
                  label="Số điện thoại *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>            
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Quận/Huyện"
                :rules="{required: districts.length > 0}"
              >
                <v-autocomplete
                  v-model="agency.huyenId"
                  :items="districts"
                  item-text="ten"
                  item-value="id"
                  label="Quận/Huyện *"
                  @change="onChangeDistrict"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Nhân viên kinh doanh"
                rules="required"
              >
                <v-autocomplete
                  v-model="agency.userIds"
                  :items="listUsers"
                  :menu-props="{ maxHeight: '230',bottom: true, offsetY: true }"
                  label="Nhân viên kinh doanh *"
                  item-text="fullName"
                  item-value="id"
                  clearable
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Phường/Xã"
                :rules="{required: wards.length > 0}"
              >
                <v-autocomplete
                  v-model="agency.xaId"
                  label="Phường/Xã"
                  :items="wards"
                  item-text="ten"
                  item-value="id"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            />
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Địa chỉ chi tiết(số nhà, đường, thôn...)"
                rules="required|max:255"
              >
                <v-textarea
                  label="Địa chỉ chi tiết(số nhà, đường, thôn...)"
                  rows="3"
                  class="ma-0 pa-0"
                  :error-messages="errors"
                  v-model="agency.detailAddress"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <div class="mt-2 text-center">
            <v-btn
              class="mb-2"
              color="primary"
              @click.prevent="handleSubmit(update)"
              v-if="checkAuthorization('agency-admin_create') || checkAuthorization('agency-admin_update') || checkAuthorization('agency-user_create')"
            >
              {{ isNew ? 'Tạo' : 'Cập nhật chỉnh sửa'
              }}
            </v-btn>
            <v-btn
              class="mb-2 mr-2"
              color="default"
              @click="goToList"
            >
              Hủy bỏ
            </v-btn>
          </div>
        </v-form>
      </validation-observer>
    </v-card>
  </v-container>
</template>
<script>
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  import * as moment from "moment";

  const AgencyRepository = RepositoryFactory.get('agency')
  const SiteRepository = RepositoryFactory.get('site')
  const AddressRepository = RepositoryFactory.get('address');

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    name: 'EditAgencyForm',
    props: {
      headerColor: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        isNew: false,
        agency: {
          name: '',
          phone: '',
          tinhId: '',
          huyenId: '',
          xaId: '',
          detailAddress: '',
          userIds: []
        },
        serviceGroups: [],
        files: null,
        thumbnailId: null,
        alertMessageText: null,
        alertMessageType: 'success',
        alert: true,
        loading: false,
        sites: [],
        provinces: [],
        districts: [],
        wards: [],
        listUsers: []
      }
    },
    computed: {
      pageTitle () {
        return this.isNew ? 'Tạo đại lý' : 'Sửa đại lý'
      },
      hasImage () {
        return this.displayImages.length ? '1' : ''
      },
      currentDate () {
        return moment().format('YYYY-MM-DD')
      },
      afterDate () {
        return moment().subtract(1, "days").format('YYYY-MM-DD')
      }
    },
    mounted () {
      let id = 0
      if ('id' in this.$route.params) {
        id = parseInt(this.$route.params.id, 10)
      }
      this.isNew = !id
      this.getDetails()
      // this.getSites()
    },
    created() {
      this.getProvinces()
      this.getListUserByPermission()
    },
    methods: {
      async update () {
        const self = this
        this.loading = this.$loading.show()

        if (this.isNew) {
          const response = await AgencyRepository.create(self.agency)
          this.loading.hide()
          if (response.error) {
            this.setAlertMessage(true, 'error', _.get(response, 'message'))
            setTimeout(() => {self.setAlertMessage(false, 'error', '')}, 3000)
          } else {
            this.$swal({
              title: 'Thêm đại lý thành công!',
              confirmButtonText: 'Đồng ý',
            },
            ).then(() => {
              this.goToList()
            })
          }
        } else {
          let id = 0
          if ('id' in this.$route.params) {
            id = parseInt(this.$route.params.id, 10)
          }
          delete self.agency.id;
          delete self.agency.createdBy;
          delete self.agency.createdBy;
          delete self.agency.updatedBy;
          delete self.agency.createdAt;
          delete self.agency.updatedAt;
          delete self.agency.deletedAt;
          delete self.agency.users;
          const response = await AgencyRepository.update(id, this.agency)
          this.loading.hide()
          if (response.error) {
            this.setAlertMessage(true, 'error', _.get(response, 'message'))
            setTimeout(() => {self.setAlertMessage(false, 'error', '')}, 3000)
          } else {
            this.$swal({
              title: 'Cập nhật đại lý thành công!',
              confirmButtonText: 'Đồng ý',
            },
            ).then(() => {
              this.goToList()
            })
          }
        }
      },
      setAlertMessage (alert, type, text) {
        this.alert = alert
        this.alertMessageText = text
        this.alertMessageType = type
      },
      async getDetails () {
        let self = this
        let id = 0
        if ('id' in this.$route.params) {
          id = parseInt(this.$route.params.id, 10)
        }
        if(!self.isNew) {
          self.loading = self.$loading.show()
          const response = await AgencyRepository.detail(id)

          if (!response.success) {
            self.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(response, 'message', '')
            },
            ).then(() => {
              this.goToList()
            })
          } else {
            self.agency = response.data
            self.getDistricts()
            self.getWards()
            self.agency.userIds = response.data.users && response.data.users.length ? response.data.users[0].id : '';
            // Object.values(response.data.users).forEach(i => {
            //   self.agency.userIds.push(i.id)
            // })
          }
          self.loading.hide()
        } else return;
      },
      goToList () {
        this.$router.push({
          name: 'AgencyList',
        })
      },
      getClass: function (headerColor) {
        return 'md-card-header-' + headerColor + ''
      },
      async getSites() {
        let res = await SiteRepository.list()
        if (res.success) {
          this.sites = _.get(res, 'data', [])
        } else {
          this.sites = []
        }
      },
      onChangeDistrict() {
        if (this.agency.huyenId) {
          this.agency.xaId = '';
          this.wards = [];
          this.getWards();
        }
      },
      onChangeProvince() {
        // if (this.agency.tinhId) {
        this.agency.huyenId = '';
        this.agency.xaId = '';
        this.districts = [];
        this.wards = [];
        this.getDistricts();
        // }
        if (this.agency.tinhId == 0) {
          this.agency.huyenId = 0;
          this.agency.xaId = 0;
        }
      },

      // khoi tao tinh/huyen/xa
      async getProvinces() {
        const respond = await AddressRepository.provinces({ limit: 100 });
        if (_.get(respond, 'success', false)) {
          this.provinces = _.get(respond, 'data', []).filter(
            data => data.id != 0
          );
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(respond, 'message', '')
          });
        }
      },
      async getDistricts() {
        const loader = this.$loading.show();
        const respond = await AddressRepository.districts(
          { limit: 100 },
          this.agency.tinhId
        );
        loader.hide();
        if (_.get(respond, 'success', false)) {
          this.districts = _.get(respond, 'data', []);
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(respond, 'message', '')
          });
        }
      },
      async getWards() {
        const loader = this.$loading.show();
        const respond = await AddressRepository.wards(
          { limit: 100 },
          this.agency.tinhId,
          this.agency.huyenId
        );
        loader.hide();
        if (_.get(respond, 'success', false)) {
          this.wards = _.get(respond, 'data', []);
          if (this.wards.length === 0) {
            this.agency.xaId = 0;
          }
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(respond, 'message', '')
          });
        }
      },
      async getListUserByPermission() {
        const getList = await AgencyRepository.getListUserByPermission({
          model:'agency-user', action:'read'
        })
        if (getList.data.success) {
          this.listUsers = _.get(getList, 'data.data', [])
        }
      }
    },
  }
</script>
<style lang="scss" scoped>
    .v-card--material {
      overflow: hidden;
    }
    .clear-both {
      clear:both;
    }
    .display-none {
      display: none;
    }
  .v-input--radio-group__input .v-input--selection-controls__ripple {
    left: -12px;
  }
</style>
